import React from 'react';
import { Breadcrumb, Dropdown, Image, Menu, Tag } from 'antd';
import './customStyles.scss';
import MobileDrawer from './mobileDrawer';
import { Link } from 'react-router-dom';

export default function Navbar() {
    const menu = (
        <Menu>
            <Menu.Item key="1">
                <a href="#trading">Trading</a>
            </Menu.Item>
            <Menu.Item key="2">
                <a href="#solutions">Solutions</a>
            </Menu.Item>
            <Menu.Item key="3">
                <a href="#commodities">Commodities</a>
            </Menu.Item>
        </Menu>
    );

    return (
        <React.Fragment>
            <nav className='navbar'>
                <Image
                    style={{ minWidth: '17vw', height: '70px' }}
                    src='./logo.png'
                    alt=''
                    className='navbar-image'
                    preview={false}
                />
                <Breadcrumb className='breadcrumb' separator='&nbsp;&nbsp;&nbsp;' style={{ position: 'relative', left: '5vw' }}>
                    <Breadcrumb.Item href='#banner'>Home</Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Dropdown overlay={menu}>
                            <a onClick={(e) => e.preventDefault()}>
                                What We Offer
                            </a>
                        </Dropdown>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href='#team'>Management Team</Breadcrumb.Item>
                    <Breadcrumb.Item href='#pthead'>Engagements</Breadcrumb.Item>
                    <Breadcrumb.Item href='#contact'>Contact Us</Breadcrumb.Item>
                    <Breadcrumb.Item href='https://vikasbandhu.in/terms&conditions'>
                        Terms
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to="/techcorner">Tech Corner</Link>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <MobileDrawer />
            </nav>
        </React.Fragment>
    );
};
